<template>
    <div>
        <p class="m-t-15 font-size-13">
            {{ $t("Please enter your email and password to login") }}
        </p>
        <div class="mb-3 loginn">
            <form @submit.prevent="login" class="submit">
                <div class="row">
                    <div class="col-md-12">
                        <div class="form-group mb-3 input-group-lg" style="position: relative">
                            <span class="input-group-text" id="basic-addon2"><i class="fas fa-envelope"></i></span>
                            <input :placeholder="$t('E-mail')" autofocus class="form-control input-lg" id="email" required
                                type="email" aria-describedby="basic-addon2" v-model="loginForm.email" />
                        </div>

                        <div class="form-group input-group-lg" style="position: relative">
                            <span style="
                                    margin-top: 10px !important;
                                    margin-left: 80%;
                                    position: absolute;
                                " @click="showPassword">
                                <i :class="className"></i></span>
                            <span class="input-group-text" id="basic-addon2">
                                <i class="fas fa-key"></i></span>
                            <input :placeholder="$t('Password')" class="form-control" id="password" required :type="type"
                                v-model="loginForm.password" />
                        </div>
                    </div>
                    <div class="col-sm-6 pt-2">
                        <router-link to="/auth/recover" class="link-login">Esqueceu sua senha?</router-link>
                    </div>
                    <div class="col-sm-6">
                        <div class="form-group text-right">
                            <b-button pill size="md" variant="primary" data-style="zoom-in" type="submit"
                                class="btn-submit px-4">ENTRAR
                            </b-button>
                        </div>
                    </div>
                    <div class="col-md-12 text-center">
                        <p class="small text-muted">
                            Quer conhecer outros produtos para a assistência
                            social do seu município?
                        </p>
                    </div>
                    <div class="col-md-12 text-center">
                        <b-link href="https://www.facebook.com/suasfacil" target="_blank" v-b-tooltip.hover
                            title="Conheça nosso Facebook" class="btn btn-circle btn-primary" style="background: #3b5998">
                            <i class="fab fa-facebook-f"></i>
                        </b-link>
                        <b-link href="https://www.instagram.com/suasfacil/" target="_blank" v-b-tooltip.hover
                            title="Conheça nosso Instagram" class="btn btn-primary btn-circle" style="background: #3f729b">
                            <i class="fab fa-instagram"></i>
                        </b-link>
                        <b-link href="https://www.linkedin.com/company/suasfacil/" target="_blank" v-b-tooltip.hover
                            title="Conheça nosso Linkedin" class="btn btn-success btn-circle" style="background: #0e76a8">
                            <i class="fab fa-linkedin-in"></i>
                        </b-link>
                        <b-link href="https://suasfacil.com.br/" target="_blank" v-b-tooltip.hover
                            title="Conheça nosso Site" class="btn btn-success btn-circle">
                            <i class="fas fa-globe"></i>
                        </b-link>
                        <b-link href="https://suasfacil.com.br/blog/" target="_blank" v-b-tooltip.hover
                            title="Conheça nosso Blog" class="btn btn-primary btn-circle">
                            <i class="fas fa-blog"></i>
                        </b-link>
                        <b-link href="https://suasfacil.com.br/trabalhe-conosco/" target="_blank" v-b-tooltip.hover
                            title="Trabalhe Conosco" class="btn btn-warning btn-circle">
                            <i class="far fa-handshake"></i>
                        </b-link>
                    </div>
                </div>
            </form>
        </div>
        <!-- <div class="m-0">
      <p>
        {{ $t("You can not access your account?") }}
        <router-link to="/auth/recover">{{
          $t("Recover account")
        }}</router-link>
      </p>
      <p class="m-0" v-if="$store.state.settings.register">
        {{ $t("Don't have an account?") }}
        <router-link to="/auth/register">{{
          $t("Create account")
        }}</router-link>
      </p>
    </div> -->
    </div>
</template>

<script>
export default {
    name: "Login",
    metaInfo() {
        return {
            title: this.$i18n.t("Login"),
        };
    },
    data() {
        return {
            loginForm: {
                email: null,
                password: null,
            },
            type: "password",
            className: "far fa-eye pt-1 mt-1 text-dark",
        };
    },
    methods: {
        showPassword() {
            if (this.type === "password") {
                this.type = "text";
                this.className = "far fa-eye-slash pt-1 mt-1 text-dark";
            } else {
                this.type = "password";
                this.className = "far fa-eye pt-1 mt-1 text-dark";
            }
        },
        login() {
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();
            axios
                .post("api/auth/login", this.loginForm)
                .then((response) => {
                    this.$store.commit("login", response.data.data);
                    this.$store.commit(
                        "pushSettings",
                        response.data.data.settings
                    );
                    this.$router.push("/dashboard/familias");
                    ladda.stop();
                })
                .catch(() => {
                    this.loginForm.password = null;
                });
        },
    },
};
</script>

<style>
.loginn .form-control {
    border-radius: 25em !important;
    padding: 0.8rem 2.5rem 0.6em 1.2em !important;
}

.loginn .input-group-text {
    position: absolute;
    top: 10px;
    right: 8px;
    background-color: transparent !important;
    border: 0;
}

.btn-circle {
    width: 30px;
    height: 30px;
    text-align: center;
    padding: 6px 0;
    font-size: 12px;
    line-height: 1.428571429;
    border-radius: 15px;
}

.btn-circle.btn-lg {
    width: 50px;
    height: 50px;
    padding: 10px 16px;
    font-size: 18px;
    line-height: 1.33;
    border-radius: 25px;
}

.btn-circle.btn-xl {
    width: 70px;
    height: 70px;
    padding: 10px 16px;
    font-size: 24px;
    line-height: 1.33;
    border-radius: 35px;
}
</style>
